const ShopReceptionAdminIconHome = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2141_25515)" />
      <path
        d="M49.1667 32.625H45V37.5L43.3333 36.4184L41.6667 37.5V32.625H37.5C37.0417 32.625 36.6667 32.9906 36.6667 33.4375V43.1875C36.6667 43.6344 37.0417 44 37.5 44H49.1667C49.625 44 50 43.6344 50 43.1875V33.4375C50 32.9906 49.625 32.625 49.1667 32.625ZM29.1667 29.375H40.8333C41.2917 29.375 41.6667 29.0094 41.6667 28.5625V18.8125C41.6667 18.3656 41.2917 18 40.8333 18H36.6667V22.875L35 21.7934L33.3333 22.875V18H29.1667C28.7083 18 28.3333 18.3656 28.3333 18.8125V28.5625C28.3333 29.0094 28.7083 29.375 29.1667 29.375ZM32.5 32.625H28.3333V37.5L26.6667 36.4184L25 37.5V32.625H20.8333C20.375 32.625 20 32.9906 20 33.4375V43.1875C20 43.6344 20.375 44 20.8333 44H32.5C32.9583 44 33.3333 43.6344 33.3333 43.1875V33.4375C33.3333 32.9906 32.9583 32.625 32.5 32.625Z"
        fill="white"
      />
      <path
        d="M36.8213 50.622C36.8213 51.1856 36.8213 51.7192 36.8213 52.2602C36.8213 52.7863 36.616 52.9967 36.0989 52.9967C35.3536 52.9967 34.6084 53.0042 33.8631 52.9967C33.4068 52.9967 33.1863 52.7787 33.1863 52.3279C33.1787 51.7643 33.1863 51.2082 33.1863 50.622C29.3384 50.622 25.5133 50.622 21.6502 50.622C21.6502 51.1706 21.6502 51.7192 21.6502 52.2602C21.6502 52.7863 21.4449 52.9891 20.9278 52.9891C20.1977 52.9891 19.4601 52.9891 18.73 52.9891C18.2129 52.9967 18 52.7863 18 52.2903C18 50.7648 18 49.2394 18 47.7139C18 47.2029 18.2129 47 18.7452 47C29.5741 47 40.3954 47 51.2243 47C51.8023 47 52 47.1954 52 47.759C52 49.2619 52 50.7573 52 52.2602C52 52.8013 51.7947 52.9967 51.2472 52.9967C50.5247 52.9967 49.8023 52.9967 49.0875 52.9967C48.5779 52.9967 48.3726 52.7863 48.365 52.2978C48.365 51.7492 48.365 51.2007 48.365 50.622C44.5171 50.622 40.692 50.622 36.8213 50.622Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2141_25515"
          x1="35"
          y1="0.461425"
          x2="35"
          y2="70.4614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F36636" />
          <stop offset="1" stop-color="#D84800" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ShopReceptionAdminIconHome
